import type { ActionModuleResponse } from '@/api/model'
import { IncentivationDataType } from '@/api/model/incentivationDataType'
import { moduleIncentivationDataType } from '../lib'

/**
 * The Score-development chart is only meaningful for modules whose instances carry a
 * numeric incentivation value — Score (`score`) or ManualInput (`enteredReward`). Binary
 * modules (and None) have nothing to plot, so the chart is hidden for them.
 */
export function moduleCanPlotScore(module: ActionModuleResponse): boolean {
  const type = moduleIncentivationDataType(module)
  return type === IncentivationDataType.Score || type === IncentivationDataType.ManualInput
}
